/**
 * * @module pages/memberships.js
 */
import regeneratorRuntime from "regenerator-runtime";
import backbone from "backbone";
import $ from "jquery";
import _ from "underscore";
import collapse from 'bootstrap/js/dist/collapse';

const Memberships = Backbone.View.extend({
  el: $(document),
  events: {
    "click .show-more.button": "showMoreItems",
  },

  initialize: function () {
    this.render();
  },

  showMoreItems: function (e) {
    const $button = $(e.target);
    const $itemsContainer = $button
      .parent()
      .prev(".season-events");
    $(".event-block", $itemsContainer).removeClass("hidden");
    
    $(e.target).parent().remove();
  },

  addShowMoreBtn: function () {
    var $showMoreBtnWrapper = $(".show-more-container");
    $showMoreBtnWrapper.append(
      '<button class="show-more button">See more</button>'
    );
  },

  showMore: function ($container) {
    const _this = this;
    const $items = $(".event-block", $container);
    const length = $items.length;

    if (length > 4) {
      const $items = $( 
        ".event-block:not(.item-1):not(.item-2):not(.item-3):not(.item-4)",
        $container
      );
      $items.addClass("hidden");

      _this.addShowMoreBtn();
    }
  },

  render: function () {
    this.showMore(".season-events-list");
    // this.showMore();
  },
});

export default Memberships;
